// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__mysrv","Item_Pesquisa":"estilo_Item_Pesquisa__642WW"};